module.exports = __webpack_public_path__ + "img/arduino.605e9676.png";